export default __webpack_public_path__ + "static/media/womens-banner.804a97a5.jpg";